import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import IconShield from '../../../assets/icons/fleet/icon-shield.svg';
import Card from '../../../components/Fleets/Card';
import Head from '../../../components/Head';
import { AuthService } from '../../../services';


const OrderReceived = () => {
  const history = useHistory();
  const [userName, setUserName] = useState<string>('');

  useEffect(() => {
    const [user] = AuthService.getUserFromToken();
    setUserName((user as any)?.firstName as string);
  }, []);

  const handleRedirect = () => {
    history.push('/dashboard');
  };

  return (
    <>
        <Head>Frotas</Head>
        <Card
          icon={IconShield}
          title={`${userName}, sua solicitação foi recebida`}
          text="Entraremos em contato através do e-mail para te posicionar sobre o
          status do pedido."
          onButtonClick={handleRedirect}
        />
    </>
  );
};
export default OrderReceived;
